import Box from '@mui/material/Box';
import type { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { getPageTitle } from 'src/config/projectConfig';
import { EdrPageHeader } from './EdrPageHeader';
import { SubscriptionUnavailableMessage } from './SubscriptionUnavailableMessage';
import { getSubscriptionUnavailableChrome } from './subscriptionUnavailable';

type SubscriptionUnavailablePageProps = {
  messageKey: string;
  chromeKey?: string;
};

export const SubscriptionUnavailablePage: FC<SubscriptionUnavailablePageProps> = ({
  messageKey,
  chromeKey,
}) => {
  const chrome = getSubscriptionUnavailableChrome(chromeKey ?? messageKey);

  return (
    <>
      <Helmet>
        <title>{getPageTitle(`Security — ${chrome.title}`)}</title>
      </Helmet>
      <Box
        p={3}
        display="flex"
        flexDirection="column"
        style={{ gap: 16, minHeight: '100%', boxSizing: 'border-box' }}
      >
        <EdrPageHeader
          breadcrumb={chrome.breadcrumb}
          title={chrome.title}
          subtitle={chrome.subtitle}
        />
        <SubscriptionUnavailableMessage messageKey={messageKey} />
      </Box>
    </>
  );
};
